export class FirmSignDevice {
    constructor() { this.firmSignDeviceId = this.firmId = this.firmDeviceId = this.RowGuidSignDevice = this.createdAt = undefined; }

    firmSignDeviceId: number;
    firmId: number;
    firmDeviceId: number;
    RowGuidSignDevice: string;
    createdAt: Date;
}